import React from 'react';
// eslint-disable-next-line
import MenuButton from './buttons';
let addButtonText = "Add";
let subtractButtonText = "Subtract";
export default class ChallengeWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionTitle: 'Select Add or Subtract'
        }
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(mathtype) {
        this.setState({ sectionTitle: mathtype });
    }

    render() {
        const sectionTitle = this.state.sectionTitle;
        return (<div>
        <button className="navigation_main col-6" onClick={() => this.handleClick('Addition')}>{addButtonText}
        <br /><span className="navigation_main-icon glyphicon glyphicon-plus">+</span></button>
        <button className="navigation_main col-6" onClick={() => this.handleClick('Subtraction')}>{subtractButtonText}
        <br /><span className="navigation_main-icon glyphicon glyphicon-minus">-</span></button>
        <MenuButton classesContainer="navigation_main col-6" classesSpan="navigation_main-icon glyphicon glyphicon-minus" containerInnerText={addButtonText} spanInnerText="+" onClick={() => this.handleClick('Addition')} />
        <MenuButton classesContainer="navigation_main col-6" classesSpan="navigation_main-icon glyphicon glyphicon-minus" containerInnerText={subtractButtonText} spanInnerText="-" onClick={() => this.handleClick('Subtraction')} />
        <main>
        <section>
        <h1>{sectionTitle}</h1>
        </section>
        </main>
        </div>)
    }
}
